import React, {  useRef } from 'react';

const Modal = ({ children, isOpen = false, setIsOpen = () => { } }) => {
    const modalRef = useRef(null);

    return (
        <div
            ref={modalRef}
            className={`modal ${isOpen ? 'show' : ''}`}
            onClick={() => setIsOpen(false)} // Close modal when clicking outside modal content
        >
            <div
                className="modal-content font-normal"
                onClick={(event) => event.stopPropagation()} // Prevent closing when clicking inside modal content
            >
                {children}
            </div>
        </div>

    );
};

export default Modal;